import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@eta/components';
import { PrimaryButton } from '@fluentui/react';
import './PrivacyPolicy.scss';
import MarkDown from '../../ContentManagement/Components/MarkDown';

export interface PrivacyPolicyProps {
    hidden: boolean;
    onClose: () => void;
    type: string;
    showCloseBtn?: boolean;
}

export const PrivacyPolicy: FC<PrivacyPolicyProps> = (
    props: PrivacyPolicyProps
) => {
    const { t } = useTranslation(['resources', 'common']);
    const { hidden, onClose, showCloseBtn, type } = props;

    return (
        <div className="privacyDialog">
            <Dialog
                hidden={hidden}
                onDismiss={() => {
                    onClose();
                }}
                maxWidth={700}
                title={<></>}
            >
                <MarkDown Type={type} />
                <br />
                {showCloseBtn && (
                    <div className="privacy">
                        <PrimaryButton
                            text={t('common:AGREE')}
                            onClick={() => onClose()}
                        />
                    </div>
                )}
            </Dialog>
        </div>
    );
};

export default PrivacyPolicy;
